import { Helmet } from "react-helmet-async"
import { CreditConsumptionView } from "../../../../SubscriptionWalletCredits"

export default function AdminCreditConsumptionAllPage() {
	return (
		<>
			<Helmet>
				<title>All Credit Consumptions</title>
			</Helmet>
			<CreditConsumptionView />
		</>
	)
}
